const doc = [({"da":({"js":({"components":({"surveys":({"layout":({"not_found_or_no_access":"Ikke fundet eller ingen adgang."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;